import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import ResearchInterests from '../components/ResearchInterests';
import Projects from '../components/Projects';
import Experience from '../components/Experience';
import Publications from '../components/Publications';
import Certificates from '../components/Certificates';
import Resume from '../components/Resume';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-academic-bg text-academic-text">
      <Header />
      <main>
        <Hero />
        <About />
        <ResearchInterests />
        <Projects />
        <Experience />
        <Publications />
        <Certificates />
        <Resume />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
